import { Card, Col, Row } from "antd";
import { UNITS } from "../../Common/Constants";

const Overview = ({ metaData }) => {
  const cardValue = (count, unit) => {
    return (
      <div className="mtb1025 text-center">
        <span className="count">{count}</span>
        <span className="card-sub-text ml015">{unit}</span>
      </div>
    );
  };

  const cardHourValue = (count, unit) => {
    const hours = Math.floor(count / 3600);
    const minutes = Math.floor((count % 3600) / 60);

    return (
      <div className="mtb1025 text-center">
        {hours ? (
          <>
            <span className="count">{hours}</span>
            <span className="card-sub-text ml015">{unit}</span>
          </>
        ) : null}
        {minutes || !hours ? (
          <>
            <span className={"count" + (hours ? " ml1" : "")}>{minutes}</span>
            <span className="card-sub-text ml015">{UNITS.MINUTES}</span>
          </>
        ) : null}
      </div>
    );
  };

  const innerContent = (
    title,
    count,
    unit,
    span,
    subHeader,
    secondValue,
    subHeaderClass
  ) => {
    return (
      <Col xs={24} sm={12} md={span} lg={span} xl={span}>
        <Card
          className="h100 overview-card-box"
          title={<div className="overview-header">{title}</div>}
        >
          {subHeader ? (
            <>
              <div className="w50 h100 border-right">
                <div className={"sub-header " + subHeaderClass}>Average</div>
                {unit === UNITS.HOURS
                  ? cardHourValue(count, unit)
                  : cardValue(count, unit)}
              </div>
              <div className="w50 h100">
                <div className={"sub-header " + subHeaderClass}>Median</div>
                {unit === UNITS.HOURS
                  ? cardHourValue(secondValue, unit)
                  : cardValue(secondValue, unit)}
              </div>
            </>
          ) : (
            <>
              {unit === UNITS.HOURS
                ? cardHourValue(count, unit)
                : cardValue(count, unit)}
            </>
          )}
        </Card>
      </Col>
    );
  };

  return (
    <>
      <Row gutter={[16, 16]} justify="space-between" className="overview mt1">
        {innerContent(
          "Total Distance Travelled",
          metaData?.totalDistance,
          UNITS.KM,
          6
        )}

        {innerContent(
          "Total Active Vehicle",
          metaData?.totalActiveVehicles,
          "",
          5
        )}

        {innerContent(
          "Total Offline Vehicle",
          metaData?.totalOfflineVehicles,
          "",
          5
        )}

        {innerContent(
          "Range",
          metaData?.range?.average,
          UNITS.KM,
          8,
          true,
          metaData?.range?.median,
          "avg"
        )}
      </Row>
      <Row gutter={[16, 16]} justify="space-between" className="overview mt1">
        {innerContent(
          "Distance Per Vehicle",
          metaData?.distance?.average,
          UNITS.KM,
          8,
          true,
          metaData?.distance?.median,
          "avg"
        )}

        {innerContent(
          "Top 5% Vehicle Distance",
          metaData?.distance?.top5?.average,
          UNITS.KM,
          8,
          true,
          metaData?.distance?.top5?.median,
          "top"
        )}

        {innerContent(
          "Bottom 5% Vehicle Distance",
          metaData?.distance?.bottom5?.average,
          UNITS.KM,
          8,
          true,
          metaData?.distance?.bottom5?.median,
          "below"
        )}

        {innerContent(
          "Usage Time",
          metaData?.usageTime?.average || 0,
          UNITS.HOURS,
          8,
          true,
          metaData?.usageTime?.median || 0,
          "avg"
        )}

        {innerContent(
          "Top 5% Vehicle Usage Time",
          metaData?.usageTime?.top5?.average || 0,
          UNITS.HOURS,
          8,
          true,
          metaData?.usageTime?.top5?.median || 0,
          "top"
        )}

        {innerContent(
          "Bottom 5% Vehicle Usage Time",
          metaData?.usageTime?.bottom5?.average || 0,
          UNITS.HOURS,
          8,
          true,
          metaData?.usageTime?.bottom5?.median || 0,
          "below"
        )}

        {innerContent(
          "Charging Time",
          metaData?.chargingTime?.average || 0,
          UNITS.HOURS,
          8,
          true,
          metaData?.chargingTime?.median || 0,
          "avg"
        )}

        {innerContent(
          "Top 5% Vehicle Charging Time",
          metaData?.chargingTime?.top5?.average || 0,
          UNITS.HOURS,
          8,
          true,
          metaData?.chargingTime?.top5?.median || 0,
          "top"
        )}

        {innerContent(
          "Bottom 5% Vehicle Charging Time",
          metaData?.chargingTime?.bottom5?.average || 0,
          UNITS.HOURS,
          8,
          true,
          metaData?.chargingTime?.bottom5?.median || 0,
          "below"
        )}
      </Row>
    </>
  );
};

export default Overview;
